<template>
  <div class="container">
    <div class="gobuy-head" v-if="!$IFR.is_iframe">
      <div class="logo">
        <img src="../../../assets/image/logo1.png" alt="" />
      </div>
      <div class="common-header-wrap">
        <mt-header :title="getTitle" class="common-header" style="box-shadow: none">
          <mt-button slot="left" icon="back" @click="goBack"></mt-button>
          <mt-button v-if="!isAddMode" style="color: #fff; font-weight: 600" slot="right" @click="onDelete(address_id)">
            {{ $t("Delete") }}
          </mt-button>
        </mt-header>
      </div>
    </div>
    <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
    <div style="padding-bottom: 100px;margin-top: 10px;">
      <div class="main_box">
        <div class="main-content">
          <!-- 国家/地区标题 -->
          <div class="title-line" style="padding-top:15px;">{{ $t("Country/Region") }}</div>
          <!-- 国家/地区选择框 -->
          <flex-line class="field-line input-wrapper" :is-link="true" :show-border="true">
            <div class="field-line-right" style="width:13.3rem;padding-left: .3rem;" slot="right" @click="navigateToCountrySelect">
              <span :class="['country-flag', address_info.country_flag_code]"></span>
              {{ this.address_info.country}}
            </div>
          </flex-line>

          <!-- 联系信息标题 -->
          <div class="title-line">{{ $t("Contact info") }}  {{this.address_info.country_flag_code}}</div>
          <!-- 收货人姓名输入框 -->
          <flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right">
              <input class="field-input" :placeholder="$t('Please enter real name')" v-model="address_info.address_realname" />
            </div>
          </flex-line>

          <!-- 联系方式 -->
          <flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right" style="display: flex; align-items: center;">
              <!-- 国家区号 -->
              <input class="field-input" style="flex: none;width: 2.2rem;border-right:1px solid #ccc;" readonly v-model="address_info.country_code" />
              <!-- 手机号 -->
              <input class="field-input" style="width: 11.3rem;" :placeholder="$t('Please enter Phone Number')" v-model="address_info.address_mob_phone" />
            </div>
          </flex-line>

          <!-- 地址标题 -->
          <div class="title-line">{{ $t("address") }}</div>
          <!-- 州/省/地区输入框 -->
          <flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right">
              <input class="field-input" :placeholder="$t('Please enter State/Province/Region')" v-model="address_info.state" />
            </div>
          </flex-line>
          <!-- 城市输入框 -->
          <flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right">
              <input class="field-input" :placeholder="$t('Please enter City')" v-model="address_info.city" />
            </div>
          </flex-line>
          <!-- 街道地址输入框 -->
          <flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right">
              <input class="field-input" :placeholder="$t('Please enter Street Address')" v-model="address_info.street" />
            </div>
          </flex-line>
          <!-- 邮政编码输入框 -->
          <flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right">
              <input class="field-input" style="width: 8rem;" :placeholder="$t('Please enter Postal Code')" v-model="address_info.postal_code" />
            </div>
          </flex-line>

          <!-- 是否设为默认地址 -->
          <flex-line :show-border="true" style="width: 93%;">
            <span class="line-name">{{ $t("default address") }}</span>
            <div slot="right">
              <mt-switch v-model="address_info.address_is_default"></mt-switch>
            </div>
          </flex-line>

          <!-- 提交按钮 -->
          <div class="pt-10 pb-10">
            <div class="common-btn ds-button-large" @click="submit">
              {{ getSumitTitle }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../assets/style/country.scss';
import { mapState, mapActions } from "vuex";
import { Toast, Indicator, MessageBox } from "mint-ui";
import RegionPicker from "../../../components/RegionPicker";
import {
  getAddressInfo,
  addAddressNew,
  delAddress,
  editAddressNew,
} from "../../../api/memberAddress";
import flexLine from "../../flexLine";

export default {
  components: {
    flexLine,
    RegionPicker,
  },
  computed: {
    ...mapState({
      config: (state) => state.config.config,
    }),
    isAddMode() {
      // 判断是添加模式还是编辑模式
      return this.$route.query.action === "add";
    },
    getTitle() {
      // 根据模式返回对应的标题
      return this.isAddMode ? this.$t("Add address") : this.$t("Edit address");
    },
    getSumitTitle() {
      // 根据是否从结账页面返回按钮标题
      return this.$route.query.isFromCheckout ? this.$t("save and use") : this.$t("save");
    },
  },
  data() {
    return {
      address_id: this.$route.query.address_id || '',
      goBackLevel: this.$route.query.goBackLevel || -1,
      address_info: {
        area_id: 108,
        address_realname: "",
        country: "India",
        country_code: "+91",
        country_flag_code: "IN",
        address_mob_phone: "",
        state: "",
        city: "",
        street: "",
        postal_code: "",
        address_is_default: true
      },
    };
  },
  created() {
    this.fetchConfig()
    if (!this.isAddMode) {
      this.fetchAddressInfo()
    }else{
      this.updateCountry()
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: "fetchConfig",
    }),
    navigateToCountrySelect() {
      this.$router.push({ name: 'SelectCountry', query: {
        address_id: this.address_id,
        action: this.$route.query.action
      } });
    },
    updateCountry() {
      this.address_info.area_id = this.$route.query.area_id
      this.address_info.country = this.$route.query.name;
      this.address_info.country_code = this.$route.query.code;
      this.address_info.country_flag_code = this.$route.query.flag;
    },
    fetchAddressInfo() {
      // 获取地址信息
      let that = this
      getAddressInfo(this.address_id)
        .then((res) => {
          let info = res.result.address_info
          // Object.assign(this.address_info, res.result.address_info);
          that.address_info.address_realname = info.address_realname
          that.address_info.address_mob_phone = info.address_mob_phone
          that.address_info.state = info.state
          that.address_info.city = info.city
          that.address_info.street = info.street
          that.address_info.postal_code = info.postal_code
          that.address_info.address_is_default = info.address_is_default == "1" ? true:false
          console.log('selected:'+this.$route.query.selected)
          if(this.$route.query.selected != 1){
            that.address_info.area_id = info.area_id
            that.address_info.country =info.country
            that.address_info.country_code = info.country_code
            that.address_info.country_flag_code = info.country_flag_code
          }else{
            that.updateCountry()
          }
        })
        .catch((error) => Toast(error.message));
    },
    onDelete(addressId) {
      // 删除地址
      MessageBox.confirm(this.$t("MessageBox.delete.address"), {
        title: this.$t("MessageBox.Tips"),
        confirmButtonText: this.$t("MessageBox.Confirm"),
        cancelButtonText: this.$t("MessageBox.Cancel"),
      }).then(() => {
        Indicator.open();
        delAddress(addressId)
          .then(() => this.goBack())
          .catch((error) => Toast(error.message))
          .finally(() => Indicator.close());
      });
    },
    goBack() {
      this.$router.push({ name: 'MemberAddressList'})
    },
    submit() {
      // 提交表单
      if (!this.validateAddressInfo()) return;
      const action = this.isAddMode ? addAddressNew : editAddressNew;
      Indicator.open();
      this.address_info.area_info = this.address_info.country+ " "+this.address_info.state+ " "+this.address_info.city
      this.address_info.address_detail = this.address_info.street
      action(this.address_info, this.address_id)
        .then(() => {
          Toast(this.$t('succ'))
          setTimeout(() => {
            this.goBack()
          }, 1500);
        })
        .catch((error) => Toast(error.message))
        .finally(() => Indicator.close());
    },
    onRegion() {
      // 打开地区选择器
      this.$refs.picker.currentValue = true;
    },
    onPickerConfirm(values) {
      // 处理地区选择结果
      this.address_info.area_id = values[0].area_id;
      this.address_info.country = values[0].name;
      this.address_info.country_code = values[0].code;  // 自动填写国家区号代码
    },
    validateAddressInfo() {
      // 验证地址信息
      const { address_realname, address_mob_phone, state, city, street, postal_code } = this.address_info;
      if (!address_realname || address_realname.length < 2 || address_realname.length > 15) {
        Toast(this.$t("Name must be 2-15 characters"));
        return false;
      }
      if (!address_mob_phone) {
        Toast(this.$t("Please fill in the phone number"));
        return false;
      }
      if (!state || !city || !street || !postal_code) {
        Toast(this.$t("Please fill in all address fields"));
        return false;
      }
      return true;
    },
    updateSelectedAddress() {
      // 更新选中的地址
      const isFromCheckout = this.$route.query.isFromCheckout;
      this.$router.go(isFromCheckout ? this.goBackLevel : this.goBack());
    },
  },
};
</script>

<style lang="scss" scoped>
.title-line{font-size: 16px;}
body {
  width: 100%;
  background-color: transparent;
  top: 100px;
  height: 100vh;
}

.ds-button-large {
  width: 80%;
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(90deg, #e8090c 0%, #f3611e);
  padding: 0.2rem;
}

::v-deep .mt-button {
  .mint-button-text {
    color: #fff;
  }
}

.container {
  min-height: 100vh;
}

.main_box {
  padding: 0px 12px;

  .main-content {
    background-image: url("../../../assets/image/go3.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 $pageSpace;

    .input-wrapper {
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      align-items: center;
      // height: 2.2rem;
      padding-left: 0.5rem;

      flex-direction: column;
      align-items: flex-start;
      margin: 0.6rem 0;
      border-radius: 12px;

      ::v-deep(.right) {
        background: #fafafa;
        border: 1px solid RGBA(205, 205, 205, 1);
        border-radius: 12px;
        padding: 0.4rem;
      }

      .field-name {
        width: 100%;
        font-size: 14px;
        font-weight: 600;
        margin: 0.5rem 0;
      }

      input {
        flex: 1;
        font-size: $subFontSize;
        flex: 1;
        width: 13.5rem;
        text-align: left !important;
        padding: 0.5rem 0.2rem;
        background: #fafafa;
      }

      .bottom-input {
        border-bottom-width: 0;
      }
    }
  }
}

.right-arrow {
  transform: rotate(-90deg);
  color: #ddd;
  font-size: $fontSize;
  display: inline-block;
}

.input-wrap {
  position: relative;

  i {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 2.4rem;
    display: block;
    width: 2rem;
    text-align: center;
    font-size: $h1;
  }
}

.notice {
  font-size: $subFontSize;
  padding: 0.5rem;
  background: #fcf8e3;
  color: #c09853;
  line-height: 1.65rem;

  .red {
    color: #f00;
  }

  .btn {
    float: right;
  }
}

::v-deep(.mint-switch-core) {
  border-color: #e7010c !important;
  background-color: #e7010c !important;
}

.gobuy-head {
  width: 100%;
  height: 4.2rem;
  position: fixed;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-image: url("../../../assets/image/homeHbgc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .logo {
    top: 25px;
    left: 12px;
    z-index: 99;
    margin: .5rem 0;

    img {
      width: 3.5rem;
    }
  }

  .common-header-wrap {
    z-index: 10;
    top: 54px;
    width: 100%;

    .common-header {
      color: #fff;
      box-shadow: none;
      background-color: #F15E60;
    }
  }

  .zhwnwei {
    height: 4.76rem;
  }
}
</style>
